import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '../components/Navigation';
import CopingResources from '../components/CopingResources';
import { Badge, Button, Card } from '../components/ui';

const ClientResourcesPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const faithEnabled = Boolean(user?.faithPreferences?.faithTrackEnabled);

  const handleDownload = (path) => {
    window.open(path, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Navigation />
      <main className="mx-auto max-w-6xl px-6 py-10">
        <div className="mb-8">
          <Badge variant="primary" className="mb-3">Client Resources</Badge>
          <h1 className="text-3xl font-display font-semibold text-neutral-900">
            Coping Resources & Support Tools
          </h1>
          <p className="mt-2 text-neutral-600">
            Choose your direction and download the resources that best fit your mental wellness path.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <Card className="flex flex-col gap-4">
            <div>
              <h2 className="text-lg font-semibold text-neutral-900">MHDF Coping Resources</h2>
              <p className="mt-1 text-sm text-neutral-600">
                Practical skills, grounding exercises, and daily coping tools.
              </p>
            </div>
            <Button onClick={() => handleDownload('/mhdf_coping_resources.pdf')}>
              Download Coping Resources PDF
            </Button>
          </Card>

          <Card className="flex flex-col gap-4">
            <div>
              <h2 className="text-lg font-semibold text-neutral-900">Faith Coping Resources</h2>
              <p className="mt-1 text-sm text-neutral-600">
                Scripture-based coping tools for the optional Faith pillar. Biblical foundations and values-based practices.
              </p>
            </div>
            <Button variant="secondary" onClick={() => handleDownload('/mhdf_faith_coping_resources.pdf')}>
              Download Faith Coping Resources PDF
            </Button>
          </Card>
        </div>

        <Card className="mt-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h3 className="text-lg font-semibold text-neutral-900">Faith Pillar (Optional 4th Practice)</h3>
            <p className="mt-1 text-sm text-neutral-600">
              {faithEnabled
                ? 'Faith pillar enabled. Access your daily scripture-based content and values reflection.'
                : 'Add faith integration as a 4th daily pillar. Biblical foundations and values-based reflection available in either pathway.'}
            </p>
          </div>
          <Button
            variant={faithEnabled ? 'primary' : 'secondary'}
            onClick={() => (faithEnabled ? navigate(`/faith/${user?.currentDay || 1}`) : navigate('/settings'))}
          >
            {faithEnabled ? 'Open Faith Pillar' : 'Enable Faith Pillar'}
          </Button>
        </Card>

        <div className="mt-10">
          <CopingResources />
        </div>
      </main>
    </>
  );
};

export default ClientResourcesPage;
